import { groupBy } from 'lodash';
import { toastConfig } from 'config';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import LynIcon from 'components/@extended/LynIcon';
import TabPanel from 'components/TabPanel/TabPanel';
import plusIcon from 'assets/images/icons/plus.svg';
import comptroller from 'assets/images/comptroller_white.svg';
import { a11yProps, existTabItems } from 'pages/globals/global';
import ListViewKeyManagementArea from './ListView-KeyManagementArea';
import { Box, Button, Grid, Stack, Tab, Tabs, Typography, useMediaQuery } from '@mui/material';
import { useGetCompanyInfoMutation, useGetModuleListMutation } from 'store/features/process/processApi';
import { useDeleteKmaMutation, useGetKMAListMutation } from 'store/features/comptroller/comptrollerApi';

const KeyManagementArea = () => {
	const theme = useTheme();
	const navigate = useNavigate();

	const [kmaList, setKmaList] = useState([]);
	const [tabsItem, setTabsItem] = useState([]);
	const [selectedTab, setSelectedTab] = useState(0);
	const [activeCreateButton, setActiveCreateButton] = useState(true);
	const [existingHierarchyNameMap, setExistingHierarchyNameMap] = useState([]);

	const { profileData } = useSelector((state) => state?.profile);

	const [getModuleList, { data: moduleList }] = useGetModuleListMutation();
	const [deleteKmaByID, { data: deleteKmaByIDdRes }] = useDeleteKmaMutation();
	const [GetCompanyInfo, { isLoading }] = useGetCompanyInfoMutation();
	const [getKmaList, { data: kmaListData }] = useGetKMAListMutation();

	const matchDownSM = useMediaQuery((theme) => theme.breakpoints.down('sm'));

	const selectTabHandler = (event, newValue) => {
		setSelectedTab(newValue);
	};

	const handleDeleteKma = ({ id }) => {
		if (id) {
			const payload = { id };

			deleteKmaByID(payload);
		}
	};

	useEffect(() => {
		getModuleList({});
	}, []);

	useEffect(() => {
		setActiveCreateButton(isLoading);
	}, [isLoading]);

	useEffect(() => {
		if (profileData) {
			GetCompanyInfo({
				companyCode: profileData?.creatorOrganizationId,
			});
		}
	}, [GetCompanyInfo, profileData]);

	useEffect(() => {
		if (profileData) {
			getKmaList({});
		}
	}, [profileData]);

	useEffect(() => {
		if (deleteKmaByIDdRes?.status === 'SUCCESS') {
			toast.success('Success! Action completed.', toastConfig);

			getKmaList({});
		} else if (deleteKmaByIDdRes?.status === 'FAILED') {
			toast.error('Failure! Action not completed.', toastConfig);
		}
	}, [deleteKmaByIDdRes]);

	useEffect(() => {
		if (kmaListData?.status === 'SUCCESS') {
			const arr1 = groupBy(kmaListData?.list, 'activationStatus');

			arr1['All'] = kmaListData?.list ?? [];

			const arr2 = Object.keys(arr1);

			const newTabs = existTabItems?.filter((item) => arr2.includes(item.data));

			setTabsItem(newTabs);
			setKmaList(arr1);

			let temp = [];

			kmaListData?.list?.map((item) => {
				temp[item?.name] = item;
				return item;
			});

			setExistingHierarchyNameMap(temp);
		}
	}, [kmaListData]);

	return (
		<Grid container rowSpacing={4.5} columnSpacing={2.75}>
			<Grid item xs={12}>
				<Grid item xs={12}>
					<Box
						sx={{
							width: '100%',
							borderRadius: 1,
						}}
					>
						<Stack
							direction="row"
							alignItems="center"
							justifyContent="space-between"
							sx={{
								px: '15px',
								py: '12px',
								color: 'common.white',
								bgcolor: '#214689',
							}}
							style={{ borderRadius: '6px 6px 0 0' }}
						>
							<Stack direction="row" alignItems="center" sx={{ gap: '10px' }}>
								<img alt="comptroller" src={comptroller} width="20px" height="18px" />

								<Typography variant="h4">Key Management Areas (KMA)</Typography>
							</Stack>

							<Button
								sx={{
									color: 'white',
									fontWeight: 450,
									display: 'flex',
									boxShadow: 'none',
									padding: '3px 15px',
									alignItems: 'center',
									transition: 'all 0.3s',
									borderColor: '#ffff',
									backgroundColor: activeCreateButton ? 'gray' : theme.palette.lynTheme.success,
									border: `1px solid ${activeCreateButton ? 'gray' : theme.palette.lynTheme.success}`,
									'&:hover': {
										backgroundColor: activeCreateButton ? 'gray' : '#207f3b',

										transform: 'scale(0.9)',
									},
								}}
								type="primary"
								disabled={activeCreateButton}
								onClick={() =>
									navigate('/comptroller/key-management-area/coe-kma', {
										state: { kmaList: kmaList['All'], existingHierarchyNameMap },
									})
								}
							>
								<img src={plusIcon} alt="add" width="12" height="12" style={{ marginRight: '8px' }} />
								Create
							</Button>
						</Stack>

						<Box sx={{ width: '100%', backgroundColor: 'white' }} style={{ borderRadius: '0px 0px 6px 6px' }}>
							<Tabs
								value={selectedTab}
								sx={{
									'& .MuiTabs-indicator': {
										backgroundColor: '#214689',
										borderRadius: '0px 0px 0px 6px',
									},
									'& .Mui-selected': {
										color: '#214689',
									},

									'& .MuiTab-root': {
										backgroundColor: 'white',
										opacity: 1,
									},
								}}
								scrollButtons
								textColor="inherit"
								allowScrollButtonsMobile
								onChange={selectTabHandler}
								aria-label="basic tabs example"
								variant={matchDownSM ? 'scrollable' : 'standard'}
							>
								{tabsItem?.map((item, index) => (
									<Tab
										key={item.label}
										label={item.label}
										iconPosition="start"
										icon={<LynIcon folder="icons" fileName={item.icon} format="svg" sx={{ marginRight: '16px' }} />}
										sx={{
											padding: '5px 50px',
										}}
										{...a11yProps(index)}
									/>
								))}
							</Tabs>
						</Box>
					</Box>

					<Box sx={{ borderBottom: 1, borderColor: 'divider', width: '100%' }}>
						{tabsItem?.map((item, index) => (
							<TabPanel key={index} value={selectedTab} index={index} sx={{ height: 'calc(100% - 38px)' }}>
								<Box sx={{ mt: 2 }}>
									<ListViewKeyManagementArea
										handleDelete={handleDeleteKma}
										isLoading={isLoading}
										kmaList={kmaList[item?.data]}
										existingHierarchyNameMap={existingHierarchyNameMap}
										moduleList={moduleList?.listLynProcessModule}
									/>
								</Box>
							</TabPanel>
						))}
					</Box>
				</Grid>
			</Grid>
		</Grid>
	);
};
export default KeyManagementArea;
